import { Grid, Typography, Collapse, Box } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import { useState } from "react";

export default function CollapsibleSection({
  label,
  children,
  ...collapseProps
}) {
  const [open, setOpen] = useState(true);
  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          mb: -1,
          cursor: "pointer",
          display: "flex",
          flexDirection: "row",
          gap: 0.5,
          zIndex: 1,
        }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <ArrowDropDown
          sx={{
            fontSize: "32px !important",
            mx: -1,
            my: -0.5,
            rotate: open ? "0deg" : "-90deg",
            transition: "all 0.2s ease-in-out",
          }}
        />
        <Box sx={{ width: "100%" }}>
          {typeof label == "string" ? (
            <Typography
              variant="h6"
              sx={{
                fontWeight: "550",
                fontSize: "15px",
                width: "100%",
              }}
            >
              {label}
            </Typography>
          ) : (
            label
          )}
        </Box>
      </Grid>
      <Collapse in={open} component={Grid} xs={12} item {...collapseProps}>
        <Grid container spacing={2} item xs={12}>
          {children}
        </Grid>
      </Collapse>
    </>
  );
}
